
const state = {
  showRightSidebar: false
}

const mutations = {
  toggleRightSidebar(state) {
    state.showRightSidebar = !state.showRightSidebar;
  }
}

const getters = {
  showRightSidebar: () => state.showRightSidebar
}

const actions = {
  async clearApiKey({ commit }) {
    commit('apiKey', null);
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
